/**
 * @readonly
 * @enum {string}
 */
export const ElectricVehicleState = Object.freeze({
    BATTERY_HEALTH: 'batteryHealth',
    BATTERY_LEVEL: 'batteryLevel',
    ESTIMATED_TIME_TO_CHARGE: 'estimatedTimeToCharge',
    EV_ROUTING_ENABLED: 'evRoutingEnabled',
    FUEL_TYPE: 'fuelType',
    IS_CHARGING: 'isCharging',
    LAST_MODIFIED: 'lastModified',
    OBJECT_ID: 'objectId',
    RANGE: 'range'
})
